var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Hero',{attrs:{"title":"Faça parte do melhor escritório de <br /> Propriedade Intelectual do Brasil!","image":"banner.jpg","height":"77vh","searchBox":true}}),_c('WhoWeAre'),_c('Area'),_c('Faq')],1)}
var staticRenderFns = []

export { render, staticRenderFns }